import ComparisonPage, { CompetitorData } from "@/components/marketing/ComparisonPage";

const competitor: CompetitorData = {
  name: "Foratable (Lunchgate)",
  slug: "foratable",
  type: "Marketplace + Gestion",
  hasCommissionPerCover: "variable",
  hasPriceCeiling: false,
  complexity: "moyenne",
  targetAudience: "Établissements en zone urbaine",
  focus: "Acquisition + Gestion",
  supportLanguage: "Allemand, Français",
  commissionPerCoverChf: "Variable selon la formule choisie",
  countryOfOrigin: "Suisse (Zurich)",
  websiteUrl: "https://www.foratable.com",
  whenToChoose: [
    "Tu souhaites attirer de nouveaux clients via la plateforme Lunchgate / Foratable",
    "Tu recherches une visibilité accrue sur une marketplace suisse",
    "Tu as une stratégie d'acquisition de nouveaux clients active",
    "Tu es prêt à investir dans la visibilité en ligne",
    "Tu acceptes un modèle hybride avec commissions possibles",
  ],
  pricingDescription:
    "Foratable (par Lunchgate) propose un modèle hybride combinant abonnement et commissions sur les réservations générées via leur marketplace. Les tarifs exacts ne sont pas publiés : ils varient selon la formule, le niveau de visibilité et le volume. Demandez un devis directement auprès de Lunchgate / Foratable.",
  conclusionStrength:
    "une visibilité sur une marketplace suisse et une stratégie d'acquisition de nouveaux clients",
  // URL is unknown to Google (GSC) — title clarifie le positionnement Foratable
  // (marketplace) vs Piktable (outil interne) pour ne pas être confondu.
  seoTitle: "Foratable (Lunchgate) vs Piktable : marketplace ou outil interne ?",
  seoDescription: "Foratable apporte des réservations via marketplace (avec commission), Piktable gère tes propres réservations sans commission. Comparatif des deux modèles pour restaurant suisse.",
};

const PiktableVsForatable = () => {
  return <ComparisonPage competitor={competitor} />;
};

export default PiktableVsForatable;
